import { Flex, Box } from "@chakra-ui/react";
import { useIntl } from "react-intl";
import { useShallow } from "zustand/react/shallow";

import { SortOrder } from "flows/ShelfChanges/pages/ShelfChangesPage";
import { BottomSheet } from "ui/BottomSheet/BottomSheet";
import {
  SortAlphabetAscendingIcon,
  SortAlphabetDescendingIcon,
  SortDescendingIcon,
} from "ui/Icons/Icons";
import { Radio } from "ui/Radio/Radio";
import { BodyM, TitleM } from "ui/Typography/Typography";

import { useRestockingServiceStore } from "../stores/restockingServiceStore";

export function RestockingSortBottomSheet({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  const intl = useIntl();
  const { sortOrder, sortBy, setSortBy, setSortOrder } = useRestockingServiceStore(
    useShallow((state) => ({
      sortOrder: state.sortOrder,
      sortBy: state.sortBy,
      setSortBy: state.setSortBy,
      setSortOrder: state.setSortOrder,
    })),
  );

  const handleClose = () => {
    onClose();
  };

  const handleSortSelection = (value: string) => {
    const [selectedSortBy, selectedSortOrder] = value.split("-") as [
      "shelf" | "priority",
      SortOrder,
    ];
    setSortBy(selectedSortBy);
    setSortOrder(selectedSortOrder);
  };

  return (
    <>
      <BottomSheet isOpen={isOpen} onClose={handleClose} backgroundColor="grey.150">
        <Box p="s200" w="100vw" maxW="22.5rem">
          <TitleM textAlign="center" mb="s200">
            {intl.formatMessage({ id: "flows.inventory.restocking-list.sort.title" })}
          </TitleM>
          <Box px="s200" py="s300" backgroundColor="white" borderRadius="sm">
            <Radio
              onChange={handleSortSelection}
              value={`${sortBy}-${sortOrder}`}
              display="flex"
              flexDirection="column"
              gap="s300"
            >
              <Radio.Item value="priority-desc">
                <Flex gap="s100" alignItems="center">
                  <SortDescendingIcon boxSize="24px" />
                  <BodyM>
                    {intl.formatMessage({
                      id: "flows.inventory.restocking-list.sort.option.priority",
                    })}
                  </BodyM>
                </Flex>
              </Radio.Item>
              <Radio.Item value="shelf-desc">
                <Flex gap="s100" alignItems="center">
                  <SortAlphabetDescendingIcon boxSize="24px" />
                  <BodyM>
                    {intl.formatMessage({
                      id: "flows.inventory.restocking-list.sort.option.shelf-desc",
                    })}
                  </BodyM>
                </Flex>
              </Radio.Item>
              <Radio.Item value="shelf-asc">
                <Flex gap="s100" alignItems="center">
                  <SortAlphabetAscendingIcon boxSize="24px" />
                  <BodyM>
                    {intl.formatMessage({
                      id: "flows.inventory.restocking-list.sort.option.shelf-asc",
                    })}
                  </BodyM>
                </Flex>
              </Radio.Item>
            </Radio>
          </Box>
        </Box>
      </BottomSheet>
    </>
  );
}
